import Vue from "vue";
import VueRouter from "vue-router";
import boardData from "@/views/boardData";
import home from "@/views/userManage/home";
import login from "@/views/login";
import layout from "@/views/layout";
import mymine from "@/views/userManage/mymine";
import square from "@/views/square";
import circle from "@/views/circle";
import newCircle from "@/views/circle/newCircle";
import tabgrade from "@/views/tabgrade";
import subJect from "@/views/subJect";
import content from "@/views/content";

Vue.use(VueRouter);

const routes = [
  { name: "login", path: "/", redirect: "/login" },
  {
    path: "/layout",
    component: layout,
    children: [
      { name: "boardData", path: "/home", component: boardData },
      { name: "home", path: "/userHome", component: home },
      {
        name: "userDeactivation",
        path: "/userDeactivation",
        component: () => import("@/views/userManage/deactivation"),
      },
      { name: "mymine", path: "/mymine", component: mymine },
      { name: "square", path: "/square", component: square },
      { name: "circle", path: "/circle", component: circle },
      { name: "newCircle", path: "/newCircle", component: newCircle },
      { name: "tabgrade", path: "/tabgrade", component: tabgrade },
      { name: "subJect", path: "/subJect", component: subJect },
      { name: "content", path: "/content", component: content },
      {
        name: "contentAppeal",
        path: "/contentAppeal",
        component: () => import("@/views/content/contentAppeal"),
      },
      {
        name: "anonymousList",
        path: "/anonymousList",
        component: () => import("@/views/content/anonymousList"),
      },
      {
        name: "anonyConfig",
        path: "/anonyConfig",
        component: () => import("@/views/content/anonymousList/anonyConfig"),
      },
      {
        name: "anonyReply",
        path: "/anonyReply",
        component: () => import("@/views/content/anonymousList/anonyReply"),
      },
      {
        name: "topContetn",
        path: "/topContetn",
        component: () => import("@/views/content/topContent"),
      },
      {
        name: "contentIndtaID",
        path: "/contentIndtaID",
        component: () => import("@/views/content/contentIndtaID"),
      },
      {
        name: "decoration",
        path: "/decoration",
        component: () => import("@/views/decoration"),
      },
      {
        name: "replyContent",
        path: "/replyContent",
        component: () => import("@/views/content/replyContent"),
      },
      {
        name: "detailReplyContent",
        path: "/detailReplyContent",
        component: () => import("@/views/content/detailReplyContent"),
      },
      {
        name: "replyDetail",
        path: "/replyContent/replyDetail",
        component: () => import("@/views/content/replyDetail"),
      },
      {
        name: "adminCheckcCricle",
        path: "/adminCheckcCricle",
        component: () => import("@/views/square/adminCheckcCricle"),
      },
      {
        name: "userRulesTmpl",
        path: "/userRulesTmpl",
        component: () => import("@/views/userManage/userRulesTmpl"),
      },
      {
        name: "realNameTmpl",
        path: "/realNameTmpl",
        component: () => import("@/views/userManage/userRulesTmpl"),
      },
      {
        name: "authenticationCategory",
        path: "/authenticationCategory",
        component: () => import("@/views/userManage/authenticationCategory"),
      },
      {
        name: "userRules",
        path: "/userRules",
        component: () => import("@/views/userManage/userRules"),
      },
      {
        name: "userRulesAuth",
        path: "/userRulesAuth",
        component: () => import("@/views/userManage/userRulesAuth"),
      },
      {
        name: "memberEdit",
        path: "/memberEdit",
        component: () => import("@/views/userManage/memberEdit"),
      },
      {
        name: "giftManagement",
        path: "/giftManagement",
        component: () => import("@/views/userManage/giftManagement"),
      },
      {
        name: "adConfig",
        path: "/adConfig",
        component: () => import("@/views/adConfig/adConfig"),
      },
      {
        name: "examineCircle",
        path: "/examineCircle",
        component: () => import("@/views/circle/examineCircle"),
      },
      {
        name: "banSpeak",
        path: "/banSpeak",
        component: () => import("@/views/circle/banSpeak"),
      },
      {
        name: "banAppeal",
        path: "/banAppeal",
        component: () => import("@/views/userManage/banAppeal"),
      },
      {
        name: "banList",
        path: "/banList",
        component: () => import("@/views/userManage/banList"),
      },
      {
        name: "userShare",
        path: "/userShare",
        component: () => import("@/views/userManage/userShare"),
      },
      {
        name: "runWallet",
        path: "/runWallet",
        component: () => import("@/views/report/runWallet"),
      },
      {
        name: "cardReport",
        path: "/cardReport/:typeId",
        component: () => import("@/views/report/cardReport"),
      },
      {
        name: "superAdmin",
        path: "/super/admin",
        component: () => import("@/views/userManage/superAdmin"),
      },
      {
        name: "withdraw",
        path: "/user/withdraw",
        component: () => import("@/views/userManage/withdraw"),
      },
      {
        name: "virtualUser",
        path: "/user/virtualUser",
        component: () => import("@/views/userManage/virtualUser"),
      },
      {
        name: "adminCircle",
        path: "/adminCircle",
        component: () => import("@/views/circle/adminCircle"),
      },
      {
        name: "artsBureau",
        path: "/artsBureau",
        component: () => import("@/views/artsBureau"),
      },
      {
        name: "serveContent",
        path: "/serveContent",
        component: () => import("@/views/myUse/serveContent"),
      },
      {
        name: "invitationPage",
        path: "/invitationPage",
        component: () => import("@/views/userManage/invitationPage"),
      },
      {
        name: "appOnlineStats",
        path: "/appOnlineStats",
        component: () => import("@/views/userManage/appOnlineStats"),
      },
      {
        name: "giftRecord",
        path: "/giftRecord",
        component: () => import("@/views/userManage/giftManagement/giftRecord"),
      },
      {
        name: "musterRanking",
        path: "/musterRanking/:url",
        component: () => import("@/views/musterRanking"),
      },
      {
        name: "messageList",
        path: "/messagePage",
        component: () => import("@/views/userManage/messageList"),
      },
      {
        name: "adminMsg",
        path: "/adminMsg",
        component: () => import("@/views/userManage/messageList/adminMsg"),
      },
      {
        name: "systemMsg",
        path: "/systemMsg",
        component: () => import("@/views/userManage/messageList/systemMsg"),
      },
      {
        name: "taskCenterPage",
        path: "/taskCenterPage",
        component: () => import("@/views/myUse/taskCenterPage"),
      },
      {
        name: "taskLog",
        path: "/taskLog",
        component: () => import("@/views/myUse/taskCenterPage/taskLog"),
      },
      {
        name: "feedBack",
        path: "/feedBack",
        component: () => import("@/views/myUse/feedBack"),
      },
      {
        name: "aboutUs",
        path: "/aboutUs",
        component: () => import("@/views/myUse/aboutUs"),
      },
      {
        name: "agreementConfig",
        path: "/agreementConfig",
        component: () => import("@/views/myUse/agreementConfig"),
      },
      {
        name: "custRelay",
        path: "/custRelay",
        component: () => import("@/views/myUse/custRelay"),
      },
      {
        name: "traffic",
        path: "/traffic",
        component: () => import("@/views/myUse/custRelay/trafficOwner"),
      },
      {
        name: "miniAppFeatures",
        path: "/miniAppFeatures",
        component: () => import("@/views/myUse/miniAppFeatures"),
      },
      {
        name: "kindReminder",
        path: "/kindReminder",
        component: () => import("@/views/userManage/userShare/kindReminder"),
      },
    ],
  },
  { path: "/login", component: login },
];
const router = new VueRouter({ routes });

export default router;
